export enum ETenure {
  FREE_HOLD = "freehold",
  YR_999 = "999-yr",
  YR_99 = "99-yr",
  YR_101 = "101-yr",
}
